<template>
  <a-modal
    ref="createModal"
    title="添加计划参数"
    :width="800"
    :visible="visible"
    :maskClosable="false"
    okText="保存"
    @cancel="close"
    @ok="confirm"
    :confirmLoading="confirmLoading"
  >
    <div class="table-page-operator-wrapper">
      <a-button @click="addLine()" type="primary">添加参数</a-button>
    </div>
    <a-table
      ref="modalTable"
      :columns="columns"
      :data-source="typeList"
      :pagination="false"
      row-key="indexId"
      :scroll="{ y: 260 }"
    >
      <span slot="parameterNameTitle">
        <i class="toRequired">*</i>参数名称
      </span>
      <span slot="parameterValueTitle">
        <i class="toRequired">*</i>参数值
      </span>
      <template v-for="item in columns" :slot="item.dataIndex" slot-scope="text, record, index">
        <div :key="item.dataIndex">
          <span v-if="item.dataIndex === 'operation'" class="table-line">
            <a @click="handleDelete(typeList, record)">删除</a>
            <a-tag v-if="record.message" color="red" class="tag">{{ record.message }}</a-tag>
          </span>
          <span v-else-if="item.type === 'select'">
            <a-select :dropdown-match-select-width="false" show-search option-filter-prop="children" v-model="record[item.dataIndex]" @change="parameterCodeChange(item.dataIndex, record, index)">
              <a-select-option v-for="(col) in setArray(item.dataList)" :key="col[item.value]">{{ col[item.label] }}</a-select-option>
            </a-select>
          </span>
          <span v-else-if="item.type === 'selectAssemble'">
            <a-select show-search option-filter-prop="children" v-model="record[item.dataIndex]" option-label-prop="label" :disabled="!record.attribute1 || record.attribute1 !== 'ORG'">
              <a-select-option v-for="(col) in setArray(item.dataList)" :key="col[item.value]" :value="col[item.value]" :label="col[item.label]">
                {{ col[item.value] }}-{{ col[item.label] }}
              </a-select-option>
            </a-select>
          </span>
          <span v-else-if="item.type === 'selectNew'">
            <a-input v-if="record.parameterValueList.length === 0" v-model="record[item.dataIndex]" :disabled="!record.parameterCode" />
            <a-select v-if="record.parameterValueList.length > 0" v-model="record[item.dataIndex]" :disabled="!record.parameterCode">
              <a-select-option v-for="(col) in record.parameterValueList" :key="col[item.value]">{{ col[item.label] }}</a-select-option>
            </a-select>
          </span>
        </div>
      </template>
    </a-table>
  </a-modal>
</template>

<script>
import { apiScpPlanParametersAdd, apiScpPlanParametersParameterValueBox } from '@/api/scp/planSetting/planParameters'
// 表单字段
export default {
  props: {
    inventOrg: {
      type: Array,
      default: () => {
        return []
      }
    },
    parameterCodeList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      // 当前控件配置:
      confirmLoading: false,
      visible: false,
      columns: [
        {
          // title: '参数名称',
          width: 150,
          dataIndex: 'parameterCode',
          scopedSlots: { customRender: 'parameterCode', title: "parameterNameTitle" },
          type: "select",
          dataList: 'parameterCodeList',
          value: 'lookupCode',
          label: 'lookupValue'
        },
        {
          title: '组织',
          width: 150,
          dataIndex: 'parameterLevelValue',
          scopedSlots: { customRender: 'parameterLevelValue' },
          type: "selectAssemble",
          dataList: 'inventOrg',
          value: 'realValue',
          label: 'label'
        },
        {
          // title: '参数值',
          width: 150,
          dataIndex: 'parameterValue',
          scopedSlots: { customRender: 'parameterValue', title: "parameterValueTitle" },
          type: "selectNew",
          value: 'realValue',
          label: 'label'
        },
        {
          title: '操作',
          width: 100,
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' }
        }
      ],
      typeList: []
    }
  },
  created () {},
  methods: {
    // 参数名称
    parameterCodeChange (dataIndex, record, index) {
      if (dataIndex === "parameterCode") {
        const itemSelect = this.parameterCodeList.find(item => {
          return item.lookupCode === record.parameterCode
        })
        record.parameterValue = ""
        record.attribute1 = itemSelect.attribute1
        this.getParameterValueBox(itemSelect.lookupCode, index)
      }
    },
    getParameterValueBox (val, index) {
      apiScpPlanParametersParameterValueBox({ parameterCode: val }).then(res => {
        const typeList = JSON.parse(JSON.stringify(this.typeList))
        typeList[index].parameterValueList = res.data && res.data.length > 0 ? res.data : [] // 参数值
        this.typeList = typeList
      })
    },
    // 删除
    handleDelete (arr, record) {
      arr.forEach((item, index) => {
        if (item.indexId === record.indexId) {
          arr.splice(index, 1);
        }
      });
    },
    show () {
      this.addLine()
      this.visible = true
    },
    // 新增行
    addLine () {
      const arr = JSON.parse(JSON.stringify(this.typeList))
      const indexId = arr.length > 0 ? arr[arr.length - 1].indexId : 0
      const obj = {
        attribute1: "",
        parameterCode: "",
        parameterLevelValue: "",
        parameterValue: "",
        message: "",
        parameterValueList: [],
        indexId: Number(indexId) + 1
      }
      arr.push(obj)
      this.typeList = arr
    },
    // 关闭模态框
    close () {
      this.reset()
      this.visible = false
    },
    // 保存
    confirm () {
      let flag = false
      for (let i = 0; i < this.typeList.length; i++) {
        if (!this.typeList[i].parameterCode || !this.typeList[i].parameterValue) {
          this.$message.warning('必填项不能为空！')
          flag = true
          return
        }
      }
      if (flag) {
        return false
      }
      this.confirmLoading = true
      apiScpPlanParametersAdd(this.typeList).then(response => {
        if (response.code === 200) {
          if (response.data && response.data.length > 0) {
            const arr = JSON.parse(JSON.stringify(this.typeList))
            arr.forEach(element => {
              element.message = ""
            });
            response.data.forEach(element => {
              arr[Number(element.lineNum) - 1].message = element.message
            });
            this.typeList = arr
            this.$message.error(response.data[0].message)
            this.confirmLoading = false
            return
          }
          this.$message.success('新增成功')
          // 关闭本组件
          this.visible = false
          // 调用外部刷新列表方法
          this.$emit('handle-success')
          // 刷新表单
          this.reset()
          this.confirmLoading = false
        } else {
          this.$message.error(response.msg)
          this.confirmLoading = false
        }
      }).catch(e => {
        this.confirmLoading = false
      })
    },
    // 表单重置
    reset () {
      this.typeList = []
    },
    setArray (arr) {
      return this[arr]
    }
  }
}
</script>

<style scoped lang="less">
/deep/.ant-select{
  width: 170px;
}
input{
  width: 170px;
}
/deep/.ant-modal-body{
  height: 400px;
  overflow-y: scroll;
}
.table-line{
  position: relative;
  .tag{
    position: absolute;
    left: -420px;
    bottom: -30px;
    z-index: 10000000;
  }
}
</style>
